import { Component, OnInit } from '@angular/core';
import { AngularFireStorage } from 'angularfire2/storage';
import { AngularFireDatabase, AngularFireObject } from 'angularfire2/database'


import { Moment } from '../models/moment'
//import { storage, initializeApp } from 'firebase';
import * as firebase from 'firebase';





@Component({
  selector: 'app-add-moment',
  templateUrl: './add-moment.component.html',
  styleUrls: ['./add-moment.component.scss']
})
export class AddMomentComponent implements OnInit {

  files: any;
  ref: any;
  task: any;
  uploadProgress: any;
  downloadURL: any;

  urls: any;
  place: any;

  moment = {} as Moment;

  fotosDone: boolean = false;

  constructor( private fireData: AngularFireDatabase, private afStorage: AngularFireStorage) {
    this.moment.allFotos = [];
    //this.moment.cityCountry = 'asd'

    this.urls = []
   }

  ngOnInit() {
  }

  addMoment(moment){
    console.log('Adding moment')
    console.log(this.moment)
    console.log(moment)
    //return
    if(this.files) {
      for (let elem of this.files) {
        console.log('Calling upload')
        this.upload(elem);
      }
      console.log('exited for loop')
    }
    console.log('checking length')
    if(this.moment.allFotos.length > 0) {
      console.log('adding main photo')
      this.moment.mainFoto = this.moment.allFotos[0]
    } else {
      console.log('no length')
      this.moment.mainFoto = '';
    }
    console.log('listing now')
    //this.fireData.list(`moments/`).push(this.moment);
  }

  getFiles(event){
    this.files = event.target.files;
  }

    async upload(event) {
      return new Promise(function (resolve, reject) {
        // create a random id
        console.log('Uploading')
        const randomId = Math.random().toString(36).substring(2);
        // // create a reference to the storage bucket location
        // this.ref = this.afStorage.ref(`moment-fotos/${randomId}`);
        //
        // //this.downloadURL = await this.task.downloadURL();
        // console.log('puttin')
        // await this.ref.putString(event);
        // console.log('put it up')
        // let newUrl = await this.ref.getDownloadURL();

        console.log('Getting stoarge reference')
        const pictures = firebase.storage().ref(`moment-fotos/${randomId}`);
        console.log('Putting image')

        let putImage = pictures.put(event);
        let imgArray = []


        var storageRef = firebase.storage().ref();
        // Upload file and metadata to the object 'images/mountains.jpg'
        var uploadTask = storageRef.child('images/' + randomId).put(event);

        // Listen for state changes, errors, and completion of the upload.
        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
          (snapshot) => {
            console.log('UOLAOSDAKSDJ')
            console.log(this.moment)
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            var progress = (snapshot['bytesTransferred'] / snapshot['totalBytes']) * 100;
            console.log('Upload is ' + progress + '% done');
            switch (snapshot['state']) {
              case firebase.storage.TaskState.PAUSED: // or 'paused'
                console.log('Upload is paused');
                break;
              case firebase.storage.TaskState.RUNNING: // or 'running'
                console.log('Upload is running');
                break;
            }
          }, (error) => {

          // A full list of error codes is available at
          // https://firebase.google.com/docs/storage/web/handle-errors
          switch (error['code']) {
            case 'storage/unauthorized':
              // User doesn't have permission to access the object
              break;

            case 'storage/canceled':
              // User canceled the upload
              break;

            case 'storage/unknown':
              // Unknown error occurred, inspect error.serverResponse
              break;
          }
        }, () => {
          // Upload completed successfully, now we can get the download URL
          console.log('getting download url')
          var downloadURL = uploadTask.snapshot.downloadURL;
          console.log(this.moment)
          //this.moment.allFotos.push(downloadURL);
          imgArray.push(downloadURL)
          console.log(downloadURL)
        });


      });


      // console.log('image put')
      //
      // let newUrl = await pictures.getDownloadURL();
      // console.log('url attained')
      // this.moment.allFotos.push(newUrl)
      // console.log('pushed url')
    }

}



// WEBPACK FOOTER //
// /Users/jmiller/Projects/Real/j-trip/j-trip/src/app/add-moment/add-moment.component.ts